import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Created with ♥ by Aniss 2020</span>
    <div class="socials">
    </div>
  `,
})
export class FooterComponent {
}
